//---------------------
// get duplicate ranks
//---------------------
export default function getDuplicateRanks(combatants) {
  console.log("---------------------");
  console.log("IN getDuplicateRanks cnt = " + combatants.length);
  let dupes = [];
  //----------------------
  // loop thru combatants
  //----------------------
  for (let i = 0; i < combatants.length; i++) {
    //---------------------------------------------
    // check for potential dupes (same rank + dex)
    //---------------------------------------------
    // cannot just check roll_off = 0 as dupe may
    // be with already rolled combatants and newly
    // added ones
    //---------------------------------------------
    dupes = combatants.filter(
      (c) => c.rank == combatants[i].rank && c.dex == combatants[i].dex && combatants[i].dupe_processed == false
    );
    //-----------------------------
    // where potential dupes exist
    //-----------------------------
    if (dupes.length > 1) {
      // console.log("got dupes = " + dupes.length);
      //----------------------------------------------------
      // check for non-zero roll-offs i.e. already resolved
      //----------------------------------------------------
      let some_already_resolved = dupes.some((a) => a.roll_off > 0);
      // console.log("some_already_resolved = " + some_already_resolved);
      //---------------------------------------------------
      // SCENARIO A. all zero roll-offs - just return tags
      //---------------------------------------------------
      if (!some_already_resolved) {
        // console.log("tag em");
        //-----------
        // tag dupes
        //-----------
        dupes.forEach((d) => (d.dupe_rank = true));
        return dupes;
        //---------------------------------------------------
        // SCENARIO B. all already resolved - return nothing
        //---------------------------------------------------
      } else {
        // console.log("some already resolved = " + some_already_resolved);
        //------------------------
        // count already resolved
        //------------------------
        let already_resolved_count = dupes.filter((a) => a.roll_off > 0).length;
        // console.log("already resolved cnt = " + already_resolved_count);
        //-----------------------------------------------
        // if all dupes already resolved - return nothing
        //------------------------------------------------
        if (already_resolved_count == dupes.length) {
          // console.log("ALL already resolved = return nothing");
          return [];
          //------------------------------------------
          // SCENARIO C. mix of un/resolved roll-offs
          //------------------------------------------
        } else {
          console.log("mixture not/already resolved");
          //-----------
          // tag dupes
          //-----------
          dupes.forEach((d) => (d.dupe_rank = true));
          return dupes;
        }
      }
    }
  }
  return [];
}
